/** id interno de la pestaña principal en ProfileForm (no cambiar sin revisar rutas y query). */
export const NETWORKING_MAIN_TAB_ID = 'networking';

/** Etiqueta visible de la pestaña en el perfil. */
export const NETWORKING_MAIN_TAB_LABEL = 'Agendar Reuniones';

/** Tablet y móvil: catálogo en la misma pestaña con vuelta al modal de reserva. */
export const NETWORKING_COMPACT_CATALOG_MQ = '(max-width: 1024px)';

export const CATALOGO_INICIATIVAS_PATH = '/catalogo-iniciativas';

const ENTRY_PROMPT_LS_PREFIX = 'networking_entry_prompt_dismissed_v1__';

/** Pestaña Agendar Reuniones visible para todos los usuarios del perfil. */
export function canSeeNetworkingTab(_userEmail?: string): boolean {
  return true;
}

/** Modal/listado de interesados en rondas (usuarios con sesión en perfil). */
export function canViewBusinessRoundsInterestedList(_userEmail?: string): boolean {
  return true;
}

export function isNetworkingEntryPromptDismissed(userEmail: string | undefined): boolean {
  const e = (userEmail || '').trim().toLowerCase();
  if (!e) return true;
  try {
    return localStorage.getItem(`${ENTRY_PROMPT_LS_PREFIX}${e}`) === '1';
  } catch {
    return true;
  }
}

export function markNetworkingEntryPromptDismissed(userEmail: string | undefined): void {
  const e = (userEmail || '').trim().toLowerCase();
  if (!e) return;
  try {
    localStorage.setItem(`${ENTRY_PROMPT_LS_PREFIX}${e}`, '1');
  } catch {
    /* ignore */
  }
}

/** Contexto para volver del catálogo al modal de reserva de networking abierto. */
export type NetworkingCatalogResume = {
  date: string;
  slotStart: string;
  manualContacts: Array<{
    fullName: string;
    email: string;
    codigoPais: string;
    numeroTelefono: string;
    organization: string;
  }>;
};

const LS_KEY = 'networking_catalog_resume_v1';

export function saveNetworkingCatalogResume(data: NetworkingCatalogResume): void {
  try {
    sessionStorage.setItem(LS_KEY, JSON.stringify(data));
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadNetworkingCatalogResume(): NetworkingCatalogResume | null {
  try {
    const raw = sessionStorage.getItem(LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as NetworkingCatalogResume;
    if (!parsed?.date || !parsed?.slotStart) return null;
    if (!Array.isArray(parsed.manualContacts)) parsed.manualContacts = [];
    return parsed;
  } catch {
    return null;
  }
}

export function clearNetworkingCatalogResume(): void {
  try {
    sessionStorage.removeItem(LS_KEY);
  } catch {
    /* ignore */
  }
}
